var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMHat2WHair2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "w-hair2_6_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D0E09B",
    d: "M551.2,99.6c-1.9-4-3.9-7.8-6.1-11.6c-10-16.9-23.4-31.7-38.8-44.1C412.7-11.7,305.2-7.3,215.5,54.5 c-28.8,19.9-55.2,46.4-74.6,74.2c-24.6,45.5-26.9,111,14.7,147.2c1.7,1.2,3.4,2.4,5.3,3.4c4.9,1.5,8.8,2.3,10.9,2.8 c10.1,2.5,23.6,2.9,33.3-0.3c-0.1,0-0.2,0-0.4-0.1c7.2-3.6,9.4-15.4,11.9-23.4c8.1-20.1,4.3-52.2,11.1-61.2 c13.8-18.3,111.3-10,132-7.3l54,2.7c-1-3.5,60.4,5.9,61.3,6.7c20,18,38.7,66,19.3,96.7c11.2-6.6,24.7-17.9,38.8-30.5 c5.8-6.9,10.8-14.3,14.9-22.1c2.3-4.4,4.4-8.8,6.2-13.4C570.5,188.5,567.5,140.5,551.2,99.6z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "hats_w-hair2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m-hat2_2_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E9C29B",
    d: "M513.4,196.7c3.8-4.3,18.8-18.2,12.5-22.5c-92.7-16.3-188.6-19.7-282.7-7.3c-12.4,1.6-24.8,3.4-37.1,5.6 c-7,1.4-14,2.8-20.9,4.5c-1.6,4.2,4.6,11.4,6.8,14.1c4.2,5,8.5,10.4,13.3,14.9c5.3,5,12,9.4,18.4,9.4 c85.6-20.2,176.6-19.3,264-3.5C499.2,211.2,506.4,204.5,513.4,196.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D3A77C",
    d: "M232.7,168.2c-8.9,1.2-17.8,2.6-26.6,4.2c-7,1.4-14,2.8-20.9,4.5c-1.6,4.2,4.6,11.4,6.8,14.1 c4.2,5,8.5,10.4,13.3,14.9c5.3,5,12,9.4,18.4,9.4c31.1-7.3,62.8-11.9,94.9-13.9C287.3,196.5,255.2,188.5,232.7,168.2z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E9C29B",
    d: "M238.7,80.7c-9.4,25.6-16.2,61.2-17,89.2c7.2-1.1,14.3-2.1,21.5-3c82-10.8,165.3-9.6,246.7,1.7 c-2.7-32.9-8.3-65.2-19.1-95.7C409.6,56,309,50.1,238.7,80.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D3A77C",
    d: "M238.7,80.7c-7.6,20.7-13.4,47.8-15.9,72.2c11.1-2.3,22.5-4.4,34-6.1c0.1-25.2,4.2-54.6,10.1-76 C257.2,73.5,247.7,76.8,238.7,80.7z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1A110C",
    d: "M222.8,152.9c-0.6,5.9-1,11.6-1.1,17c7.2-1.1,14.3-2.1,21.5-3c82-10.8,165.3-9.6,246.7,1.7 c-0.4-5.2-0.9-10.4-1.5-15.5C407.8,134.8,306.8,135.1,222.8,152.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#947D70",
    d: "M442.2,144.8c-7.9-1-15.8-1.9-23.9-2.7l0.9,19.1c8,0.5,16.1,1.1,24.1,1.9L442.2,144.8z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMHat2WHair2);
export default __webpack_public_path__ + "static/media/m-hat2_w-hair2.8e9147ffc48137c6d146255fb309820e.svg";
export { ForwardRef as ReactComponent };